/* eslint-disable import/no-cycle */
import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { resetAllModals, changeModalState } from 'actions/modalActions'
import ModalAlert from 'components/modal-alert'
import MODAL_NAMES from 'constants/modalNames'

import { Container } from './styled'

const ModalRedirectionPaymentGateway = ({ redirectionPaymentGateway, changeModalState }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState()

  const confirmRedirect = () => {
    setLoading(true)
    window.location.href = window.location.origin + redirectionPaymentGateway
  }

  const closeModal = () => {
    changeModalState({
      isVisible: false,
      modalName: MODAL_NAMES.REDIRECTION_PAYMENT_GATEWAY
    })
  }

  return (
    <Container>
      <ModalAlert
        width={'506px'}
        isLoading={loading}
        title={t('general.modal-redirection-payment-gateway.title')}
        sublines={[t('general.modal-redirection-payment-gateway.description')]}
        confirmAction={() => confirmRedirect()}
        modalName={MODAL_NAMES.REDIRECTION_PAYMENT_GATEWAY}
        paddingRightTitle
        closePage={() => closeModal()}
      />
    </Container>
  )
}

const mapDispatchToProps = {
  resetAllModals,
  changeModalState
}

export default connect(null, mapDispatchToProps)(ModalRedirectionPaymentGateway)
